(function () {
  if (customElements.get('op-cart-ubicacion')) return;

  var STORE_KEY = 'op-envios:zone';
  var geoPromises = {};

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function loadGeo(url) {
    if (!geoPromises[url]) {
      geoPromises[url] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          return data.geo || [];
        })
        .catch(function (e) {
          delete geoPromises[url];
          throw e;
        });
    }
    return geoPromises[url];
  }

  function readSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY)) || null;
    } catch (e) {
      return null;
    }
  }

  function writeSaved(zone) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(zone));
    } catch (e) {}
  }

  function currentZone() {
    var saved = readSaved();
    return saved && saved.region && saved.city ? saved : null;
  }

  function checkoutUrl(zone) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var q = [
      'checkout[shipping_address][country]=CL',
      'checkout[shipping_address][province]=' + encodeURIComponent(zone.region),
      'checkout[shipping_address][city]=' + encodeURIComponent(zone.city)
    ];
    return base + 'checkout?' + q.join('&');
  }

  class OpCartUbicacion extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.texts = {};
      try {
        this.texts = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) {}
      this.required = this.dataset.required === 'true';
      this.regionSel = this.querySelector('[data-cu-region]');
      this.citySel = this.querySelector('[data-cu-city]');
      this.errorEl = this.querySelector('[data-cu-error]');
      this.geo = [];
      var self = this;

      this.regionSel.addEventListener('change', function () {
        self.fillCities(self.regionSel.value, '');
        writeSaved({ region: '', city: '' });
        self.clearError();
      });
      this.citySel.addEventListener('change', function () {
        if (self.regionSel.value && self.citySel.value) {
          writeSaved({ region: self.regionSel.value, city: self.citySel.value });
        }
        self.clearError();
      });

      loadGeo(this.dataset.rulesUrl)
        .then(function (geo) {
          self.geo = geo;
          self.fillRegions();
          self.restore();
        })
        .catch(function () {
          self.hidden = true;
        });
    }

    fillRegions() {
      var self = this;
      this.regionSel.replaceChildren(new Option(this.texts.regionPlaceholder, ''));
      this.geo.forEach(function (r) {
        self.regionSel.add(new Option(r.name, r.code));
      });
      this.regionSel.disabled = false;
    }

    regionByCode(code) {
      return this.geo.filter(function (r) {
        return r.code === code;
      })[0];
    }

    fillCities(code, city) {
      var region = this.regionByCode(code);
      this.citySel.replaceChildren(new Option(this.texts.cityPlaceholder, ''));
      this.citySel.disabled = !region;
      if (!region) return;
      var self = this;
      region.communes.forEach(function (c) {
        self.citySel.add(new Option(c, c));
      });
      if (city) this.citySel.value = city;
    }

    restore() {
      var saved = currentZone();
      var region = saved && this.regionByCode(saved.region);
      if (!region) return;
      var n = norm(saved.city);
      var commune = region.communes.filter(function (c) {
        return norm(c) === n;
      })[0];
      if (!commune) return;
      this.regionSel.value = region.code;
      this.fillCities(region.code, commune);
    }

    showError(text) {
      this.classList.add('op-cu--invalid');
      this.errorEl.textContent = text;
      this.errorEl.hidden = false;
      (this.regionSel.value ? this.citySel : this.regionSel).focus();
    }

    clearError() {
      this.classList.remove('op-cu--invalid');
      this.errorEl.hidden = true;
    }
  }

  customElements.define('op-cart-ubicacion', OpCartUbicacion);

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var submitter = event.submitter;
      if (!form.closest || !form.closest('cart-drawer')) return;
      if (!submitter || submitter.name !== 'checkout') return;
      var picker = document.querySelector('cart-drawer op-cart-ubicacion');
      if (!picker) return;
      var zone = currentZone();
      if (!zone) {
        if (picker.required) {
          event.preventDefault();
          picker.showError(picker.texts.requiredMessage);
        }
        return;
      }
      event.preventDefault();
      window.location.href = checkoutUrl(zone);
    },
    true
  );
})();
